// import { useContext } from "react"
import Slider from "react-slick"
import kebabCase from "lodash.kebabcase"
import cc from "classcat"
import Highlighter from "react-highlight-words"
import LocalizedLink from "components/LocalizedLink"
import Quote from "components/molecules/common/Quote"

const H2 = ({ className, children }) => (
  <h2
    className={cc([
      "m-0 mt-2 whitespace-pre-line text-left text-3xl font-extrabold tracking-tight text-white sm:text-5xl",
      className,
    ])}
  >
    {children}
  </h2>
)

const CustomDot = () => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <circle cx="8" cy="8" r="4" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm0-2A6 6 0 1 0 8 2a6 6 0 0 0 0 12Z"
      fill="rgb(39, 39, 42)"
    />
  </svg>
)

const QuotesCarousel = ({
  title,
  slides,
  children,
  bgColor = "green",
  sliderBgColor = "green",
}) => {
  const settings = {
    className: "center",
    infinite: true,
    slidesToScroll: 1,
    speed: 600,
    autoplaySpeed: 10000,
    autoplay: true,
    dots: true,
    arrows: false,
    customPaging: CustomDot, // li content with slick-active class on it when active, color applied with tailwind.css
    dotsClass: `slick-dots black-on-${sliderBgColor}`, // green, white, yellow or black
  }

  return (
    <div
      className={cc([
        "relative",
        {
          "bg-zinc-800": bgColor === "black",
          "bg-kkm-green": bgColor === "green",
        },
      ])}
    >
      <div
        className={cc([
          "absolute inset-0 hidden w-1/2 rounded-r-full lg:block",
          {
            "bg-kkm-green ": sliderBgColor === "green",
            "bg-kkm-yellow": sliderBgColor === "yellow",
          },
        ])}
      />
      <div className="lg:grid lg:grid-cols-2">
        <div className="lg:order-last">
          <div className="mx-auto flex h-full max-w-3xl items-center px-4 py-12 sm:px-6 md:py-16 lg:ml-0 lg:max-w-[40rem] lg:px-8 lg:py-24 lg:pl-14">
            {title && (
              <H2 className="text-white">
                <Highlighter
                  highlightClassName="text-sb-green mt-10 bg-transparent animate-pulse-slow"
                  searchWords={["59%"]}
                  autoEscape
                  textToHighlight={title}
                />
              </H2>
            )}
            {children}
          </div>
        </div>
        <div
          className={cc([
            "relative lg:bg-transparent",
            {
              "bg-kkm-green ": sliderBgColor === "green",
              "bg-kkm-yellow": sliderBgColor === "yellow",
            },
          ])}
        >
          <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:mr-0 lg:max-w-[40rem] lg:px-8 lg:py-32 lg:pr-14">
            <Slider slidesToShow={1} {...settings}>
              {slides.map((item) =>
                item.inboundLink ? (
                  <LocalizedLink
                    to={item.inboundLink}
                    key={kebabCase(item.title)}
                  >
                    <Quote content={item} />
                  </LocalizedLink>
                ) : (
                  <Quote content={item} key={kebabCase(item.title)} />
                ),
              )}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  )
}

export default QuotesCarousel
